import Calendar from "./Calendar";
import dayjs from "dayjs";

export default function FiltersSection({
    filters,
    selectedFilters,
    setSelectedFilters,
    filteredCards,
    icons,
    isMobile,
    datesEventsHappening,
}) {
    // Variables.
    let whenFilter = [
        {
            slug: "this-week",
            name: "This week",
        },
        {
            slug: "this-month",
            name: "This month",
        },
        {
            slug: "next-month",
            name: "Next month",
        },
    ];

    /**
     * Event handlers *****
     */

    const displayMoreFilters = (event) => {
        event.preventDefault();

        event.currentTarget.ariaExpanded = toggleAria(
            event.currentTarget.ariaExpanded,
        );

        let targetAriaHidden = toggleAria(event.currentTarget.ariaExpanded);

        let filterVals = {
            ...selectedFilters,
            hideMoreFilters: targetAriaHidden,
        };

        setSelectedFilters(filterVals);
    };

    /**
     *  Change handler - Event category (checkboxes)
     */
    const categoryCheckBoxChange = (event) => {
        let slug = event.currentTarget.dataset.slug;
        let categoriesArr = selectedFilters.categories;

        if (slug) {
            searchDeleteAdd(categoriesArr, slug);

            let filterVals = {
                ...selectedFilters,
                is_filtered: true,
                categories: categoriesArr,
            };

            setSelectedFilters(filterVals);
        }
    };

    /**
     *  Change handler - Event when (checkboxes)
     */
    const whenCheckBoxChange = (event) => {
        let slug = event.currentTarget.dataset.slug;
        let filterVals;

        if (!slug) {
            return false;
        }

        const index = selectedFilters.when.indexOf(slug);

        if (index !== -1) {
            filterVals = {
                ...selectedFilters,
                is_filtered: false,
                when: [],
                when_sel_dates: [],
            };
        } else {
            // Get the selected dates.
            let whenSelectedDates = [];
            if (slug == "this-week") {
                whenSelectedDates = getNext7Days();
            } else if (slug == "this-month") {
                whenSelectedDates = getRemaningDaysOfMonth();
            } else if (slug == "next-month") {
                whenSelectedDates = getNextMonthDates();
            } else {
                whenSelectedDates = [];
            }

            filterVals = {
                ...selectedFilters,
                is_filtered: true,
                when: [slug],
                when_sel_dates: whenSelectedDates,
            };
        }

        setSelectedFilters(filterVals);
    };

    /**
     *  Change handler - Event composers (checkboxes)
     */
    const composersCheckBoxChange = (event) => {
        let slug = event.currentTarget.dataset.slug;
        let composersArr = selectedFilters.composers;

        if (slug) {
            searchDeleteAdd(composersArr, slug);

            let filterVals = {
                ...selectedFilters,
                is_filtered: true,
                composers: composersArr,
            };

            setSelectedFilters(filterVals);
        }
    };

    /**
     *  Change handler - Event locations (checkboxes)
     */
    const locationCheckBoxChange = (event) => {
        let slug = event.currentTarget.dataset.slug;
        let locationsArr = selectedFilters.locations;

        if (slug) {
            searchDeleteAdd(locationsArr, slug);

            let filterVals = {
                ...selectedFilters,
                is_filtered: true,
                locations: locationsArr,
            };

            setSelectedFilters(filterVals);
        }
    };

    /**
     *  Get next 7 days. Does functionality for this week.
     */
    const getNext7Days = () => {
        let selDates = [];

        const today = dayjs();
        for (let i = 0; i < 7; i++) {
            const nextDate = today.add(i, "day");
            selDates.push(nextDate.toDate());
        }

        return selDates;
    };

    /**
     *  Get remaining dates of the month. Does functionality for this month.
     */
    const getRemaningDaysOfMonth = () => {
        const today = dayjs().startOf("day");

        // Get the last day of the current month
        const lastDayOfMonth = dayjs().endOf("month").startOf("day");

        const dates = [];
        let currentDate = today;

        while (
            currentDate.isBefore(lastDayOfMonth) ||
            currentDate.isSame(lastDayOfMonth, "day")
        ) {
            dates.push(currentDate.toDate());

            currentDate = currentDate.add(1, "day");
        }

        return dates;
    };

    /**
     *  Get next month dates. Does functionality for next month
     */
    const getNextMonthDates = () => {
        const nextMonthStart = dayjs().add(1, "month").startOf("month"); // Get the start of next month
        const daysInNextMonth = nextMonthStart.daysInMonth(); // Get the number of days in next month

        const selDates = [];
        for (let i = 0; i < daysInNextMonth; i++) {
            const date = nextMonthStart.add(i, "day");
            selDates.push(date.toDate());
        }

        return selDates;
    };

    // = = = = = = = = = = = = = = = = = = = = End Event handlers.

    /**
     *  Helper functions *****
     */

    function toggleAria(value) {
        value = value === "true" ? true : false;
        return !value;
    }

    /**
     *  Search an element, delete if its exist, add if it doesn't.
     * @param Array array
     * @param string element
     */
    function searchDeleteAdd(array, element) {
        const index = array.indexOf(element);

        if (index !== -1) {
            // If element exists, delete it
            array.splice(index, 1);
        } else {
            // If element doesn't exist, add it
            array.push(element);
        }
    }

    // Render JSX.
    return (
        <div className="">
            <form className="">
                {/** Top filters  */}
                <div className="top-filters" id="top-filters">
                    {/** Filter: Category  */}
                    <fieldset id="filter-category" className="filter-category">
                        <legend className="filter-category__legend">
                            <h4 className="filter-category__title">What?</h4>
                        </legend>

                        <ul className="filter-category__list" data-cat-filter>
                            {filters.categories?.length > 0
                                ? filters.categories.map((item) => (
                                      <li
                                          className="filter-category__list-item"
                                          key={item.slug}
                                      >
                                          <input
                                              name=""
                                              type="checkbox"
                                              id={item.slug}
                                              data-slug={item.slug}
                                              checked={
                                                  selectedFilters.categories.includes(
                                                      item.slug,
                                                  )
                                                      ? true
                                                      : false
                                              }
                                              onChange={categoryCheckBoxChange}
                                              className="filter-category__list-item-input"
                                          />

                                          <label
                                              className="filter-category__list-item-label custom"
                                              htmlFor={item.slug}
                                          >
                                              <span className="close-icon">
                                                  {icons.close_icon}
                                              </span>

                                              {item.name.replaceAll(
                                                  "&amp;",
                                                  "&",
                                              )}
                                          </label>
                                      </li>
                                  ))
                                : null}
                        </ul>
                    </fieldset>

                    {/** Filter: When  */}
                    <fieldset id="filter-when" className="filter-category">
                        <legend className="filter-category__legend">
                            <h4 className="filter-category__title">When?</h4>
                        </legend>

                        <ul className="filter-category__list">
                            {whenFilter.length > 0
                                ? whenFilter.map((item) => (
                                      <li
                                          className="filter-category__list-item"
                                          key={item.slug}
                                      >
                                          <input
                                              name=""
                                              type="checkbox"
                                              id={item.slug}
                                              data-slug={item.slug}
                                              checked={
                                                  selectedFilters.when.includes(
                                                      item.slug,
                                                  )
                                                      ? true
                                                      : false
                                              }
                                              onChange={whenCheckBoxChange}
                                              className="filter-category__list-item-input"
                                          />

                                          <label
                                              className="filter-category__list-item-label custom"
                                              htmlFor={item.slug}
                                          >
                                              <span className="close-icon">
                                                  {icons.close_icon}
                                              </span>
                                              {item.name.replaceAll(
                                                  "&amp;",
                                                  "&",
                                              )}
                                          </label>
                                      </li>
                                  ))
                                : null}
                            <li className="filter-category__list-item">

                                {/** Calendar icon button  */}
                                <button className="filter-category__btn custom" onClick={displayMoreFilters} aria-label="Show calendar button">
                                    {icons.calendar_btn}
                                </button>
                            </li>
                        </ul>

                    </fieldset>
                </div>

                <button
                    className="more_filters--btn"
                    aria-controls="more-filters"
                    aria-expanded="false"
                    onClick={displayMoreFilters}
                >
                    {icons.more_filters}
                    {selectedFilters.hideMoreFilters
                        ? "More filters"
                        : "Fewer filters"}
                </button>

                {/** More filters  */}
                <div
                    className="top-filters collapse"
                    id="more-filters"
                    aria-hidden={selectedFilters.hideMoreFilters ? true : false}
                >
                    {/** Filter: composer  */}
                    <fieldset id="filter-composer" className="filter-category">
                        <legend className="filter-category__legend">
                            <h4 className="filter-category__title">Composer</h4>
                        </legend>

                        <ul
                            className="filter-category__list"
                            data-composer-filter
                        >
                            {filters.composers?.length > 0
                                ? filters.composers.map((item) => (
                                      <li
                                          className="filter-category__list-item"
                                          key={item.slug}
                                      >
                                          <input
                                              name=""
                                              type="checkbox"
                                              id={item.slug}
                                              data-slug={item.slug}
                                              checked={
                                                  selectedFilters.composers.includes(
                                                      item.slug,
                                                  )
                                                      ? true
                                                      : false
                                              }
                                              onChange={composersCheckBoxChange}
                                              className="filter-category__list-item-input"
                                          />

                                          <label
                                              className="filter-category__list-item-label custom"
                                              htmlFor={item.slug}
                                          >
                                              <span className="close-icon">
                                                  {icons.close_icon}
                                              </span>
                                              {item.name.replaceAll(
                                                  "&amp;",
                                                  "&",
                                              )}
                                          </label>
                                      </li>
                                  ))
                                : null}
                        </ul>
                    </fieldset>

                    {/** Filter: location  */}
                    <fieldset id="filter-composer" className="filter-category">
                        <legend className="filter-category__legend">
                            <h4 className="filter-category__title">Location</h4>
                        </legend>
                        <ul
                            className="filter-category__list"
                            data-location-filter
                        >
                            {filters.locations?.length > 0
                                ? filters.locations.map((item) => (
                                      <li
                                          className="filter-category__list-item"
                                          key={item.slug}
                                      >
                                          <input
                                              name=""
                                              type="checkbox"
                                              id={item.slug}
                                              data-slug={item.slug}
                                              checked={
                                                  selectedFilters.locations.includes(
                                                      item.slug,
                                                  )
                                                      ? true
                                                      : false
                                              }
                                              onChange={locationCheckBoxChange}
                                              className="filter-category__list-item-input"
                                          />

                                          <label
                                              className="filter-category__list-item-label custom"
                                              htmlFor={item.slug}
                                          >
                                              <span className="close-icon">
                                                  {icons.close_icon}
                                              </span>
                                              {item.name.replaceAll(
                                                  "&amp;",
                                                  "&",
                                              )}
                                          </label>
                                      </li>
                                  ))
                                : null}
                        </ul>
                    </fieldset>

                    {/** Calendar  */}
                    <div id="cal_datepicker" className="calendar-container ">
                        <legend className="filter-category__legend">
                            <h4 className="filter-category__title">Date</h4>
                        </legend>

                        {datesEventsHappening?.length ? (
                            <Calendar
                                datesEventsHappening={datesEventsHappening}
                                selectedFilters={selectedFilters}
                                setSelectedFilters={setSelectedFilters}
                            />
                        ) : null}
                    </div>
                </div>

            </form>
        </div>
    );
}
